import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { classNames } from '@geerd-nx/utils';

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorBackgroundColor?: string;
  }
>(({ className, value, indicatorBackgroundColor, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={classNames(
      'relative h-2 w-full overflow-hidden rounded-full bg-primary-50',
      className || ''
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary-500 transition-all"
      style={{
        transform: `translateX(-${100 - (value || 0)}%)`,
        backgroundColor: indicatorBackgroundColor,
      }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
